module.exports = __webpack_public_path__ + "app/modals/reset-vehicle-counter.view.html";